<!-- QUESTION COLOR -->
<div class="colorPicker items animate__animated animate__flipInY" [class.ios]="utils.ios()" [class.android]="utils.android()">
  @if (user?.color != null) {
    <button mat-button class="closeBtn" [class.ios]="utils.ios()" [class.iosPadding]="utils.ios()" [class.android]="utils.android()" [class.androidPadding]="utils.android()" (click)="change.emit(false)"><mat-icon>close</mat-icon></button>
  }
  <div class="item">
    <div class="question" (click)="getColors();utils.sound('click-face');">
      <mat-icon class="question-icon">color_lens</mat-icon>
      <span class="question-title">Color</span>
    </div>
    <p class="text-center question-sub">Choose a color which vibes with you.</p>
  </div>
  <div class="item color">
    <mat-radio-group>
      @for (color of colors; track color) {
        <mat-radio-button [value]="color" [style.background-color]="color"
        (click)="clickColor(color)"></mat-radio-button>
      }
    </mat-radio-group>
  </div>
  <div class="largeIcon text-center" (click)="getColors();utils.sound('click-face');">
    <mat-icon>refresh</mat-icon>
  </div>
</div>